import React, { FC } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { colors as dsColors } from '@modernhealth/vital-foundation';

import { colors } from '../../themes/colors';

type Props = {
  title: string;
  description: React.ReactNode | string;
};

export const InfoCard: FC<Props> = ({ title, description }) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <InfoIcon fontSize="small" className={styles.icon} />
        <Typography className={styles.title}>{title}</Typography>
      </div>

      <Typography className={styles.description}>{description}</Typography>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    borderRadius: 5,
    backgroundColor: dsColors.violet05,
    padding: '11px 16px',
    margin: '20px 0',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  icon: {
    color: dsColors.violet55,
    fontSize: 17,
  },
  title: {
    color: colors.black1,
    fontSize: 15,
    lineHeight: '24px',
    fontWeight: 800,
  },
  description: {
    color: colors.black2,
    marginTop: 10,
    fontWeight: 500,
  },
});
